// @flow

import validateAddress from './validateAddress'

export default [
  ...validateAddress,
]
